module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-card-h-1fade2071603e3d24ac43b466ea805de.webp";